import React from 'react';
import useCampaignSearch from '@/lib/hooks/swr/useCampaignSearch';

function CampaignValue({ value = [] }: { value: string[] }) {
  const { data } = useCampaignSearch({ pageSize: 1000 });

  return data ? (
    <span>
      {value
        .reduce<string[]>((arr, campaignId) => {
          const displayName = data.campaigns.find(
            (campaign) => campaignId === campaign.campaignId,
          )?.displayName;
          return displayName ? [...arr, displayName] : arr;
        }, [])
        .join(', ')}
    </span>
  ) : null;
}

export default CampaignValue;
